import { ContentBlock } from "./contentBlock";

export type FaqSection = {
    _type: 'faqSection';
    _key: string;
    title: string;
    faqItems: Array<{
        question: string;
        answer: string;
    }>;
}

export const isFaqSection = (block: ContentBlock): block is FaqSection => {
    return block._type === 'faqSection';
}
